module.exports = __webpack_public_path__ + "static/media/codeKey.5b63bd5a.jpg";